module.exports = __webpack_public_path__ + "img/artist.20c768d7.jpg";